import script from "./NetworkAccess.vue?vue&type=script&setup=true&lang=ts"
export * from "./NetworkAccess.vue?vue&type=script&setup=true&lang=ts"

import "./NetworkAccess.vue?vue&type=style&index=0&id=2b1feb0b&scoped=true&lang=less"

import exportComponent from "/Users/wangwangao/Desktop/project/浦东-外接/vue3-TS-vant-env/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b1feb0b"]])

export default __exports__